export const ROOM_TYPES = [
  { id: 'living',   label: 'Living Room',  color: '#4CAF50' },
  { id: 'bedroom',  label: 'Bedroom',      color: '#2196F3' },
  { id: 'kitchen',  label: 'Kitchen',      color: '#FF9800' },
  { id: 'bathroom', label: 'Bathroom',     color: '#9C27B0' },
  { id: 'dining',   label: 'Dining Room',  color: '#FF5722' },
  { id: 'study',    label: 'Study Room',   color: '#795548' },
  { id: 'balcony',  label: 'Balcony',      color: '#00BCD4' },
  { id: 'garage',   label: 'Garage',       color: '#607D8B' },
  { id: 'other',    label: 'Other Area',   color: '#9E9E9E' },
];
